export enum ProjectShowHideColumnsEnum {
  Project = 0,
  Table = 1,
  OrderLine = 2,
}
